import {
  ConnectIframe,
  ConnectIframeProps,
} from '../../internal/iframe/connectIframe';
import Connect from '../../main/connect';

// eslint-disable-next-line import/no-default-export
export default Connect(({ ...props }: ConnectIframeProps) => (
  <ConnectIframe
    {...props}
    width="100%"
    options={{ autoresize: true }}
    moduleType="fileViews"
  />
));
